import { IconLock } from '@swaggerhub-portal/component-library'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

export const ProductVisibility = ({ isPreview, accentColor }: { isPreview?: boolean, accentColor?: string }) => {
  const { t } = useTranslation()

  return (
    <div
      aria-label={t('portal.landingPage.productTile.requestAccess.productVisibility.ariaLabel')}
      className={clsx(
        'w-8 h-8 flex items-center justify-center rounded pointer-events-auto border-1.5',
        'text-neutral-80 bg-neutral-10 border-neutral-40 dark:text-neutral-50 dark:bg-neutral-90 dark:border-neutral-80',
        !isPreview && 'hover:bg-neutral-80 hover:text-neutral-00 hover:border-none',
        !isPreview && 'dark:hover:bg-neutral-30 dark:hover:text-neutral-95',
        !accentColor && 'border-accent-60'
      )}
      style={{ borderColor: accentColor }}
    >
      <IconLock />
    </div>
  )
}